export default "__VITE_ASSET__d12e1b39__"